export const NOTIFICATION_TYPES = {
  CASE: "case",
  LAW_FIRM: "lawfirm",
  USER: "user",
  CASE_NOTES: "casenotes",
};
